import React, { forwardRef } from 'react';
import cn from 'classnames';
import omit from 'lodash/omit';
import A11y from 'chameleon/ui-stack/utilities/a11y';

const Row = forwardRef(
  (
    {
      row,
      className,
      children,
      isDisabled = false,
      includeDefaultRoleProp = true,
      ...otherProps
    },
    ref,
  ) => {
    const customRowProps = row.getRowProps();

    if (customRowProps.role && !includeDefaultRoleProp) {
      delete customRowProps.role;
    }

    return (
      <A11y key={otherProps.key} ignoreEvents={otherProps.a11yIgnoreEvents}>
        <tr
          ref={ref}
          key={row.original.number}
          {...customRowProps}
          {...omit(otherProps, 'a11yIgnoreEvents', 'rowId')}
          className={cn(
            'border-bottom',
            { 'hover:bg-blue-100': !isDisabled },
            { 'cursor-pointer': otherProps.onClick && !isDisabled },
            className,
          )}
        >
          {children}
        </tr>
      </A11y>
    );
  },
);

export default Row;
